import { render, staticRenderFns } from "./AddressPick.vue?vue&type=template&id=4395160c&scoped=true"
import script from "./AddressPick.vue?vue&type=script&lang=js"
export * from "./AddressPick.vue?vue&type=script&lang=js"
import style0 from "./AddressPick.vue?vue&type=style&index=0&id=4395160c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395160c",
  null
  
)

export default component.exports